import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  font-weight: 700;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray[100]};

  border-radius: 8px;
  background-color: ${({ theme, disabled }) =>
    !disabled ? theme.colors.orange.primary : theme.colors.gray[500]};
  border: none;
  padding: 0 35px;

  transition: 0.2s ease;

  height: 48px;

  .arrow {
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 10px;
  }

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
